import { Reducer } from '../../../../@types';
import { UserTypes } from '../../../../@types/enums';
import { initialState, UserState } from './initialState';

export const authReducer: Reducer<UserState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case UserTypes.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UserTypes.LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
        ...action.payload?.permissions,
        loading: false,
      };
    case UserTypes.LOGIN_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case UserTypes.UPDATE_LANG_REQUEST:
      return {
        ...state,
      };
    case UserTypes.UPDATE_LANG_SUCCESS:
      return {
        ...state,
        locale: action.payload,
      };
    case UserTypes.UPDATE_LANG_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};
